export interface IDestinationData {
  Aliases: string[];
  CountryId: number;
  Country: string;
  CountryLocal: string;
  CountryPhoneCode: string;
  PopularityOrder: number;
  IsCovered: boolean;
  AreaId: number;
  Phone: string;
  CountryISOCode: string;
  IsDomestic: boolean;
}

export enum DestinationType {
  Domestic = 1,
  Abroad = 2
}
